import { Localization } from "../../../common/localizable-component";
import { VideoplayerLocalization } from "./videoplayer-types";

export const VIDEOPLAYER_LOCALIZATION: Localization<VideoplayerLocalization> = {
  en: {
    play: "Play",
    pause: "Pause",
    continue: "Continue",
    replay: "Replay",
    toggleFullscreen: "Enter/Leave Fullscreen Mode",
    togglePlayPause: "Play/Pause",
    toggleMute: "Mute/Unmute",
    posterAltDefault: "video poster",
    posterTitleDefault: "video poster",
    percentPlayed: "{0} played",
    unableToPlay: "Unfortunately, we are unable to play the video.",
    videoTagNotSupported: "Your browser does not support the <video> tag."
  },
  de: {
    play: "Abspielen",
    pause: "Pausieren",
    continue: "Fortsetzen",
    replay: "Nochmal abspielen",
    toggleFullscreen: "Vollbild an/aus",
    togglePlayPause: "Abspielen/Pausieren",
    toggleMute: "Ton an/aus",
    posterAltDefault: "Video Poster",
    posterTitleDefault: "Video Poster",
    percentPlayed: "{0} abgespielt",
    unableToPlay: "Leider können wir das Video nicht abspielen.",
    videoTagNotSupported: "Ihr Browser unterstützt das <video> tag leider nicht."
  },
  sv: {
    play: "Spela",
    pause: "Pausa",
    continue: "Fortsätt",
    replay: "Spela igen",
    toggleFullscreen: "Öppna/Lämna helskärmsläge",
    togglePlayPause: "Spela/Pausa",
    toggleMute: "Ljud av/Ljud på",
    posterAltDefault: "bakgrundsbild video",
    posterTitleDefault: "bakgrundsbild video",
    percentPlayed: "{0} spelade",
    unableToPlay: "Tyvärr kan vi inte spela upp videon.",
    videoTagNotSupported: "Din webbläsare stöder inte <video>."
  },
  nl: {
    play: "Speel",
    pause: "Pauzeer",
    continue: "Ga door",
    replay: "Replay",
    toggleFullscreen: "Volledig scherm modus openen/verlaten",
    togglePlayPause: "Afspelen/Pauze",
    toggleMute: "Mute/Unmute",
    posterAltDefault: "video poster",
    posterTitleDefault: "video poster",
    percentPlayed: "{0} gespeeld",
    unableToPlay: "Helaas kunnen we de video niet afspelen.",
    videoTagNotSupported: "Uw browser ondersteunt de <video> tag niet."
  },
  it: {
    play: "Riproduci",
    pause: "Interrompi",
    continue: "Continua",
    replay: "Ripeti",
    toggleFullscreen: "Entra/Esci dalla modalità a schermo intero",
    togglePlayPause: "Riproduci/Interrompi",
    toggleMute: "Silenzia/Attiva audio",
    posterAltDefault: "avviso video",
    posterTitleDefault: "avviso video",
    percentPlayed: "{0} riprodotto",
    unableToPlay: "Sfortunatamente, non siamo in grado di riprodurre il video.",
    videoTagNotSupported: "Il tuo browser non supporta il tag di <video>."
  },
  hu: {
    play: "Lejátszás",
    pause: "Szünet",
    continue: "Folytatás",
    replay: "Visszajátszás",
    toggleFullscreen: "Teljes képernyőre váltás / Kilépés a teljes képernyős módból",
    togglePlayPause: "Lejátszás/Szüneteltetés",
    toggleMute: "Némítás/Némítás feloldása",
    posterAltDefault: "Videó közzététele",
    posterTitleDefault: "Videó közzététele",
    percentPlayed: "{0} lejátszva",
    unableToPlay: "Sajnos a videó lejátszása nem lehetséges.",
    videoTagNotSupported: "Sajnos a használt böngésző nem támogatja a beágyazott videó használatát."
  },
  da: {
    play: "Afspil",
    pause: "Pause",
    continue: "Fortsæt",
    replay: "Genafspil",
    toggleFullscreen: "Fuld skærm/Afslut fuld skærm",
    togglePlayPause: "Afspil/Pause",
    toggleMute: "Lyd fra/Lyd til",
    posterAltDefault: "video plakat",
    posterTitleDefault: "video plakat",
    percentPlayed: "{0} afspillet",
    unableToPlay: "Vi kan desværre ikke afspille videoen.",
    videoTagNotSupported: "Browseren understøtter ikke <video>"
  },
  fr: {
    play: "Jouer",
    pause: "Pause",
    continue: "Continuer",
    replay: "Replay",
    toggleFullscreen: "Entrer/sortir du mode plein écran",
    togglePlayPause: "Lecture/Pause",
    toggleMute: "Mute/Unmute",
    posterAltDefault: "poster vidéo",
    posterTitleDefault: "poster vidéo",
    percentPlayed: "{0} jouée",
    unableToPlay: "Malheureusement, nous ne sommes pas en mesure de lire la vidéo.",
    videoTagNotSupported: "Votre navigateur ne prend pas en charge la balise <video>."
  },
  es: {
    play: "Play",
    pause: "Pausar",
    continue: "Continuar",
    replay: "Repetir",
    toggleFullscreen: "Entrar/Salir del modo de pantalla completa",
    togglePlayPause: "Play/Pausa",
    toggleMute: "Silenciar/activar",
    posterAltDefault: "póster de vídeo",
    posterTitleDefault: "póster de vídeo",
    percentPlayed: "jugados",
    unableToPlay: "Lamentablemente, no podemos reproducir el vídeo.",
    videoTagNotSupported: "Su navegador no soporta la etiqueta <video>."
  },
  pl: {
    play: "Odtwórz",
    pause: "Wstrzymaj",
    continue: "Kontynuuj",
    replay: "Powtórz",
    toggleFullscreen: "Wejście/wyjście z trybu pełnoekranowego",
    togglePlayPause: "Odtwórz/Wstrzymaj",
    toggleMute: "Wyciszenie/wyłączenie wyciszenia",
    posterAltDefault: "plakat wideo",
    posterTitleDefault: "plakat wideo",
    percentPlayed: "{0} grano",
    unableToPlay: "Niestety, nie jesteśmy w stanie odtworzyć tego filmu.",
    videoTagNotSupported: "Twoja przeglądarka nie obsługuje znacznika <video>."
  },
  ro: {
    play: "Joacă",
    pause: "Pauză",
    continue: "Continuă",
    replay: "Redare",
    toggleFullscreen: "Intrați/ieșiți din modul ecran complet",
    togglePlayPause: "Redare/Pauză",
    toggleMute: "Mute/Unmute",
    posterAltDefault: "poster video",
    posterTitleDefault: "poster video",
    percentPlayed: "{0} redat",
    unableToPlay: "Din păcate, nu putem reda videoclipul.",
    videoTagNotSupported: "Browserul dvs. nu acceptă tag-ul <video>."
  },
  hr: {
    play: "Igraj",
    pause: "Pavza",
    continue: "Nadaljuj",
    replay: "Ponovitev",
    toggleFullscreen: "Vstopite/zapustite celozaslonski način",
    togglePlayPause: "Predvajaj/Premor",
    toggleMute: "Izklopi/Vklopi zvok",
    posterAltDefault: "video plakat",
    posterTitleDefault: "video plakat",
    percentPlayed: "{0} igral",
    unableToPlay: "Žal videoposnetka ne moremo predvajati.",
    videoTagNotSupported: "Vaš brskalnik ne podpira oznake <video>."
  },
  cs: {
    play: "Přehrát",
    pause: "Pozastavit",
    continue: "Pokračovat",
    replay: "Přehrát",
    toggleFullscreen: "Vstup/výstup z celoobrazovkového režimu",
    togglePlayPause: "Přehrát/pozastavit",
    toggleMute: "Ztlumit/vypnout zvuk",
    posterAltDefault: "video plakát",
    posterTitleDefault: "video plakát",
    percentPlayed: "{0} přehrává se",
    unableToPlay: "Video se nám bohužel nedaří přehrát.",
    videoTagNotSupported: "Váš prohlížeč nepodporuje značku <video>"
  },
  sl: {
    play: "Igraj",
    pause: "Prekinitev",
    continue: "Nadaljuj",
    replay: "Ponovitev",
    toggleFullscreen: "Vstop/izstop iz celozaslonskega načina",
    togglePlayPause: "Predvajanje/počasno predvajanje",
    toggleMute: "Izklop/izklop zvoka",
    posterAltDefault: "video plakat",
    posterTitleDefault: "video plakat",
    percentPlayed: "{0} predvajano",
    unableToPlay: "Žal ne moremo predvajati videoposnetka.",
    videoTagNotSupported: "Vaš brskalnik ne podpira oznake <video>."
  }
};
